import styled from 'styled-components';

import FilterBar from 'components/shared/filters/FilterBar';
import { FilterSection } from 'components/shared/filters/FilterSlideout';
import Tabs, { TabType } from 'components/Tabs';

import InsightsDateRangePicker from './InsightsDateRangePicker';

type Props = {
  title: string | React.ReactNode;
  gtmPrefix: string;
  tabs: TabType[];
  selectedTab?: TabType;
  onTabClick: (tab: TabType) => void;
  filters: Record<string, any>;
  filterSections: FilterSection[];
  setSelectedFilters: (filters: Record<string, any>) => void;
};

export default function InsightsTabsFilterBar({
  title,
  gtmPrefix,
  tabs,
  selectedTab,
  onTabClick,
  filters,
  filterSections,
  setSelectedFilters,
}: Props) {
  const handleClearFilters = () => {
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        setSelectedFilters({ [key]: [] });
      }
    });
  };

  return (
    <FilterBar
      showSearchInput={false}
      applyFilters={setSelectedFilters}
      filters={filters}
      showResults={false}
      filterSections={filterSections}
      onClearFilters={handleClearFilters}
      title={title}
      callToActionShowMinWidth={0}
      callToAction={
        <InsightsDateRangePicker gtmPrefix={gtmPrefix} filters={filters} setSelectedFilters={setSelectedFilters} />
      }>
      {tabs.length > 1 && (
        <TabsWrapper>
          <Tabs tabs={tabs} onTabClick={onTabClick} selectedTab={selectedTab} />
        </TabsWrapper>
      )}
    </FilterBar>
  );
}

const TabsWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  margin-bottom: -24px;
`;
